<template>
	<div >
		<el-dialog :visible.sync="showprintwin" title="选择模板" :width="isprint==1?'900px':'600px'" 
		:close-on-click-modal="false" lock-scroll :modal-append-to-body="false" :show-close="true" 
		:destroy-on-close="true">
			<div class="printwin" style="height:320px;overflow-y:auto;margin-top:-20px" align="center">
				<table class="htmltable">
					<tr>
						<td>
							<label style="color:blue;font-size:15pt;padding-left:15px">【打印顺序】是指模板输出的优先顺序</label>
							<pl-table :data="printmode" :style="{ width:`${tablewidth}px` }">
								<pl-table-column prop="e_modename" label="模板名称" min-width="50%"></pl-table-column>
								<pl-table-column prop="printenabeld" label="开启打印" width="80">
									<template slot-scope="scope">
										<el-switch v-model="scope.row.printenabeld" active-value="1" inactive-value="0" @change="checkedprint(scope.row)"></el-switch>
									</template>
								</pl-table-column>
								<pl-table-column prop="printindex" label="打印顺序" width="80">
									<template slot-scope="scope">{{scope.row.printindex}}</template>
								</pl-table-column>
							</pl-table>
						</td>
					</tr>
				</table>
			</div>
			 <span slot="footer" class="dialog-footer">
				 <div style="text-align: center;">
					 <el-button type="success" @click="SurePrint" size="mini">确 定</el-button>
					 <el-button @click="CancelPrint" size="mini">取 消</el-button>
				 </div>
			  </span>
		</el-dialog>
		<el-dialog :visible.sync="showprintset" :title="printsettitle" width="750px" :close-on-click-modal="false" lock-scroll :modal-append-to-body="false" :show-close="false">
			<printset ref="printset" :checkprinter="checkprinter" @printcheckcallback="printcheckcallback"></printset>
		</el-dialog>
	</div>
</template>

<script>
import Utils from '../../lib/util.js';
import tableui from '@/components/table/tablegrid.vue';
import printset from '../../pages/user/printset.vue';
export default {
	components: {
		tableui,
		printset
	},
	props: {},
	data() {
		return {
			showprintwin: false, //弹窗显示
			selectedprintmodeindex: 0,
			e_modename: '',
			tablewidth:'530px',
			gridheight:'280px',
			loading:false,
			printmode: [
				{
					e_code: '',
					e_modename: '',
					printenabeld: '0',
					printindex: '',
					printer:'',//打印机
					pgname:'',//纸张名称
					layout:''//打印方向
				}
			],
			layout:[{value:'1',label:'纵向'},{value:'2',label:'横向'}],//打印方向
			printer:[],//打印机
			pgname:[],//纸张名称
			localprinter: '',
			batch: '',
			pageparam: {},
			mode: '',
			fun: '',
			handlertype: '',
			isperview: 'false',
			pkval: '',
			searchinfo: '',
			funcode: '',
			isorder: true, //是否顺序打印
			parentpage: {},
			orderinfo: {},
			orderlist: [],
			checkedprintmode: [], //已选打印模板列表
			checkAll: false,
			isprint:0,
			ecode:'',
			printset:'',
			diskpath:'',
			divclass:'printwin',
			errorfile:'',
			expresscomname:'',
			handtype:'',
			isgrid:false,
			isreshowrate:false,
			iserror:true,
			filenamerule:'',
			downtype:'',
			filepath:'',
			sys:'包裹管理',
			istransorder:false,
			isrollback:false,
			errorcount:0,
			errorbatch:'',
			errormsg:'',
			showprintset:false,
			checkprinter:true,
			printsettitle:'打印机检测',
			l_id:''
		};
	},
	mounted() {
		
	},
	methods: {
		init(param) {
			import('../../static/' + this.$theme + '/style/logisticsmanager/printhandler.scss');
			//debugger
			var that = this;
			that.isgrid = param.isgrid;
			that.pkval = param.pkval;
			that.searchinfo = param.searchinfo;
			that.funcode = param.funcode;
			that.pageparam = param.pageparam;
			that.ecode = param.ecode;
			that.expresscomname= param.expresscomname;
			that.batch = param.batch;
			that.isrollback = param.isrollback;
			that.orderinfo = param.orderinfo;
			that.orderlist = param.orderlist;
			that.checkedprintmode=[];
			that.isreshowrate=param.isreshowrate;
			if(param.l_id!=undefined)
				that.l_id=param.l_id;
			that.errorfile='';
			that.errorbatch='';
			that.errormsg='';
			that.errorcount=0;
			that.isorder=true;
			if(param.istransorder!=undefined)
				that.istransorder=param.istransorder;
			if(param.sys!=undefined)
				that.sys=param.sys;
			that.diskpath='';
			if(param.filenamerule!=undefined)
				that.filenamerule=param.filenamerule;
			if(param.downtype!=undefined)
				that.downtype=param.downtype;
			if(param.filepath!=undefined)
				that.filepath=param.filepath;
			if(param.iserror!=undefined)
				that.iserror=param.iserror;
			//debugger
			//that.modecol=JSON.parse(JSON.stringify(that.defaultcol));
			if(param.isprint==undefined) //是否打印，1-打印，需加载选择打印机，打印纸张，布局
				that.isprint=0;
			else{
				that.isprint=param.isprint;	
			}
			if(that.isprint==1)
				that.tablewidth='830';
			else
				that.tablewidth='530';
			
			//that.parentpage=that.parentpage;
			if (param.isorder != undefined) that.isorder = param.isorder;
			
			that.handtype = param.handtype; //操作方法 1--取单号 2--取快递单并打印 3-取快递单并预览 4-取单号并订阅 5-取单号订阅+打印 6-取单号订阅+预览 7-取单号订阅+预览+扣费
			this.$tool.loadingclose();
			if(that.isprint==1){
				this.showprintset=true;
				if(this.$refs.printset!=undefined)
					this.$refs.printset.init();
			}
			else
				this.Startprinthandler();
		},
		printhandle(e){
			if(e.event=='checkedprint'){
				this.checkedprint(e.row);
			}
		},
		printcheckcallback(e){
			if(e.state==1){
				this.showprintset=false;
				if(e.success)
					this.Startprinthandler();
			}
			else
				this.printsettitle='打印设置';
		},
		Startprinthandler(){
			var that=this;
			if (that.funcode == '01') that.PrintHandler();
			//获取权限内的打印模板
			else if (that.funcode == '02'|| that.funcode == '07')//已选择模板
				////已选快递公司，直接打印 07需要多加一个打印海关文件 
				that.SurePrint();
			else if (that.funcode == '03')
				//批量预览
				that.PrintPerView();
			else if (that.funcode == '04')
				//已选定快递公司，循环批量下单，最后合并打印
				that.BatchPrint();
		},
		//开启打印
		checkedprint(row) {
			var that = this;
			this.printmode.forEach(e => {
				e.printindex='';
			});
			if (row.printenabeld =="1"){
				this.checkedprintmode = this.checkedprintmode.concat(JSON.parse(JSON.stringify(row)));
			}
			else{
				var rowindex=-1;
				for(var i=0;i<this.checkedprintmode.length;i++){
					rowindex++;
					if(this.checkedprintmode[i].e_code==row.e_code)
						break;
				}
				if(rowindex>-1)
					this.checkedprintmode.splice(rowindex, 1);
			}
			var printindex = 0;
			this.checkedprintmode.forEach(e => {
				that.printmode.forEach(p => {
					if (p.e_code == e.e_code) {
						printindex++;
						p.printenabeld='1';
						p.printindex = printindex;
						p.printer=e.printer;
						p.layout=e.layout;
						p.pgname=e.pgname;
					}
				});
			});
		},
		//获取权限内的打印模板
		PrintHandler() {
			var that = this;
			debugger
			this.$tool.loading('正在获取打印模板', that.pageparam.divclass);
			this.$apipost.post.CheckPmodetoPrint({ handlerparam: JSON.stringify(that._data) }).then(res => {
				this.$tool.loadingclose();
				if (res.state == '1') {
					//debugger
					if(res.batch!=undefined)
						that.batch=res.batch;
					if (res.orderlist.length > 0) {
						//表示所选订单的打印模板只有一个，直接可以循环打印
						//调用打印方法
						that.StartPrint(res.orderlist);
					} else {
						//debugger
						var printmode=[];
						var checkedprintmode=[];
						var ecode=that.ecode;
						if(ecode==''||ecode==undefined)
							ecode=localStorage.getItem('ecode');
						res.printmode.forEach(e=>{
							e.printer='';
							e.pgname='';
							e.layout='';
							e.printindex='';
							if(e.e_code==ecode){
								e.printenabeld='1';
								e.printindex=1;
								printmode=printmode.concat(e);
								checkedprintmode.push(e);
							}
							else{
								e.printenabeld='0';
								printmode=printmode.concat(e);
							}
						});
						if(checkedprintmode.length==0){
							printmode[0].printindex=1;
							printmode[0].printenabeld='1';
							checkedprintmode.push(printmode[0]);
						}
						that.printmode =JSON.parse(JSON.stringify(printmode));
						if(that.isprint=='1')
							that.checkedprint(JSON.parse(JSON.stringify(checkedprintmode))[0]);
						else
							that.checkedprintmode=JSON.parse(JSON.stringify(checkedprintmode));
						// if(res.batch!=undefined)
						// 	that.batch=res.batch;
						that.showprintwin = true;
						if(that.$parent.showsuccesswin!=undefined)
							that.$parent.showsuccesswin = false;
					}
				} else {
					this.$tool.message(res.message, 0);
				}
			});
		},
		//确认打印
		SurePrint() {
			//debugger
			var that = this;
			var ecode='';
			var printset=[];			
			if(that.checkedprintmode.length>0){
				printset=[];
				for(var j=0;j<that.checkedprintmode.length;j++){
					//筛选
					for(var i=0;i<that.printmode.length;i++){
						if(that.checkedprintmode[j].e_code==that.printmode[i].e_code){
							printset=printset.concat(that.printmode[i]);
							break;
						}
					}
				}
			}else{
				if(that.checkedprintmode.length==0&&!that.showprintwin){
					if(that.ecode!=''&&that.ecode!=undefined){
						printset=[{e_code:this.ecode,
										e_modename:this.expresscomname,
										printer:'',
										pgname:'',
										layout:'',
										printindex:''}];
						that.checkedprintmode=printset;
					}
					else{
						this.$tool.message('请选择模板', 0);
						return false;
					}
				}
				else{
					this.$tool.message('请选择模板', 0);
					return false;
				}
			}
			that.printset=printset;
			if (that.printset.length>0) {
				this.$tool.loading('正在打印', that.divclass);
				if(that.batch!=undefined&&that.batch!=''){
					//获取临时表订单
					this.$apipost.get.GetTempBatch({ batch: that.batch }).then(res => {
						this.$tool.loadingclose();
						if(res.state=='1')
						{
							if(res.list.length>0)
								that.StartPrint(res.list);
						}
						else
							this.$tool.message(res.message, 0);
					});
				}
				else{
					that.StartPrint([{pkval:that.pkval}]);
				}
			} else {
				this.$tool.loadingclose();
				this.$tool.message('请选择打印模板', 0);
			}
		},
		//开始打印
		StartPrint(orderlist) {
			var that = this;
			var isgo = true;
			if (that.handtype == 13||that.handlertype==14) {
				//打印面单
				//判断是否安装了打印控件
				if (!this.$tool.checkprintcontrol()) {
					this.$tool.loadingclose();
					this.$tool.opendowncontrol();
					isgo = false;
				}
			}
			if (isgo) {
				if (that.isorder) {
					//按顺序
					this.$tool.loadingclose();
					that.ForPrint(orderlist, 0);
				} else {
					//无顺序，多线程的
					that.ThreadPrint(orderlist);
				}
			}
		},
		//按顺序循环打印
		ForPrint(list, index,gf) {
			var that = this;
			if(that.checkedprintmode.length==0)
				that.printset=[];
			//下单，有三种需求，后台就有三种组合方法，1-仅取单号 2-打印(取单号+生成面单+打印)  3-预览(取单号+生成面单+预览) 是文件预览的，返回的是链接，是lodop预览或者打印的，返回lodop代码
			if (list.length > index) {
				if(that.checkedprintmode.length==0){
					this.$tool.loadingclose();
					if(list[index].e_code!='')
						that.printset=[{e_code:list[index].e_code,e_modename:list[index].e_modename,printer:list[index].printer,pgname:list[index].pgname,layout:list[index].layout,printindex:''}];
						
					if(gf!=undefined){
						that.printset.push({e_code:gf.e_code,e_modename:gf.e_modename,printer:gf.printer,pgname:gf.pgname,layout:gf.layout,printindex:''});
					}
				}
				var paraminfo = {
					orderinfo: list[index],
					index: index,
					handtype: that.handtype,
					handlerparam: that._data,
					userid: localStorage.getItem('userid'),
					printset:that.printset,
					diskpath:that.diskpath,
					otherparam:that.pageparam.checkedexpress,
					filenamerule:that.filenamerule,
					downtype:that.downtype,
					filepath:that.filepath,
					batch:that.errorbatch,
					ordercount:list.length
				};
				//return false;
				if(this.showprintwin)
					this.$tool.loading('正在打印第' + (parseInt(index) + 1) + '/' + list.length + '个订单', that.divclass);
				else
					this.$tool.loading('正在生成第' + (parseInt(index) + 1) + '/' + list.length + '个订单', that.pageparam.divclass);
				 //console.log('打印', encodeURIComponent(JSON.stringify(paraminfo)));
				// debugger
				// if(2>1)
				//return false;
				//debugger
				this.$apipost.post.GoOrderPrint({ paraminfo: JSON.stringify(paraminfo) }).then(res => {
					that.$tool.loadingclose();
					localStorage.setItem('ecode',that.printset[0].e_code);
					if (res.state != undefined) {
						if(res.batch!=undefined)
							that.errorbatch=res.batch;
						//debugger
						if (res.state == '1') {
							if (res.diskpath != '' && res.diskpath != undefined){
								that.diskpath=decodeURIComponent(res.diskpath);
							}
							if(res.filename!=undefined&&that.errorfile==''){
								that.errorfile=decodeURIComponent(res.filename);
								that.errorcount=(parseInt(that.errorcount)+1);
								if(parseInt(that.errorcount)<3)
								 	that.errormsg=that.errormsg+list[index].pkval+' '+res.message+'  ';
								this.$emit('printcallback', {
									p_pkval:list[index].pkval,
									handtype:that.handtype,
									issuccess:false,
									message:'操作失败',
									istransorder:that.istransorder,
									l_id:that.l_id
								});
								if(that.iserror){
									that.showprintwin=false;
									this.$tool.alertmessage(res.message);
									index = parseInt(list.length) + 1;
								}
								else
									index = parseInt(index) + 1;
							}
							else{
								this.$emit('printcallback', {
									p_pkval:list[index].pkval,
									handtype:that.handtype,
									issuccess:true,
									istransorder:that.istransorder,
									l_id:that.l_id
								});
								index = parseInt(index) + 1;
							}
							that.ForPrint(list, index,gf);
						} else {
							that.errorcount=(parseInt(that.errorcount)+1);
							if(parseInt(that.errorcount)<3)
							 	that.errormsg=that.errormsg+list[index].pkval+' '+res.message+'  ';
							if (that.isrollback) {
								this.$apipost.post.RollBack_Order({ pkval: list[index].pkval, p_batch: '', batch: '', isdeltemp: 1 }).then(resmsg => {
									that.pageparam.pkval='';
									that.pageparam.p_pkval='';
									that.pkval='';
								});
							}
							this.$emit('printcallback', {
								p_pkval:list[index].pkval,
								handtype:that.handtype,
								issuccess:false,
								message:res.message,
								istransorder:that.istransorder,
								l_id:that.l_id
							});
							
							if(that.iserror){
								that.showprintwin=false;
								this.$tool.alertmessage(res.message);
								index = parseInt(list.length) + 1;
							}
							else
								index = parseInt(index) + 1;
								
							that.ForPrint(list, index,gf);
						}
					} else {
						if(res.indexOf('%')>-1)
							eval(res);
						else
							eval(decodeURIComponent(res));
						
						this.$emit('printcallback', {
							p_pkval:list[index].pkval,
							handtype:that.handtype,
							issuccess:true,
						    istransorder:that.istransorder,
							l_id:that.l_id
						});
						if(that.handtype==14){
							if (CLODOP.blOneByone==true){
								 CLODOP.On_Return = function (TaskID, Value) {
								     if (Value) 
								 		index = parseInt(index) + 1;
								 	that.ForPrint(list, index,gf);
								 }
							}
							else{
								CLODOP.On_Return = function (TaskID, Value) {
								    if (Value) 
										index = parseInt(index) + 1;
									that.ForPrint(list, index,gf);
								}
							}
						}
						else
						{
							index = parseInt(index) + 1;
							that.ForPrint(list, index,gf);
						}
					}
				}).catch(e=>{
					that.showprintwin=false;
					var message='网络异常，请重试';
					this.$tool.alertmessage(message);
					if (that.isrollback) {
						this.$apipost.post.RollBack_Order({ pkval: list[index].pkval, p_batch: '', batch: '', isdeltemp: 1 }).then(resmsg => {
							that.pageparam.pkval='';
							that.pageparam.p_pkval='';
							that.pkval='';
						});
						that.iserror=true;
					}
					this.$emit('printcallback', {
						p_pkval:list[index].pkval,
						handtype:that.handtype,
						issuccess:false,
						message:message,
						istransorder:that.istransorder,
						l_id:that.l_id
					});
					index = parseInt(list.length) + 1;
					that.ForPrint(list, index,gf);
				});
			} else {
				if (index == list.length) {
					//debugger
					if(that.errorcount>0&&!that.iserror){
						if(that.errorfile!=undefined&&that.errorfile!='')
							this.$tool.downfile(that,that.errorfile,that.errorbatch);
						that.showprintwin=false;
						if(that.errorcount>3)
							that.errormsg=that.errormsg+'... ';
						that.errormsg=that.errormsg+'  共'+that.errorcount+'单操作失败。';
						
						this.$tool.alertmessage(that.errormsg);
					}
					this.$tool.loadingclose();
					if (that.isgrid) {
						//this.$tool.message('操作完成', 1);
						//需要刷新列表
						that.$parent.refreshgrid(true);
					}
					if (that.funcode == '07') {
						//下载海关文件
						that.orderinfo = {
							pkval: that.pkval
						};
						that.PrintPerView_Customs();
					} else {
						if(that.errorfile!='')
							that.pageparam.errorfile=that.errorfile;
						if(that.diskpath!=''){
							//合并文件
							if(that.handtype==14)
								that.getzipfile();
							else
								that.MergePdf();
						}
						else{
							if(that.isprint=='1'){
								this.$tool.message('打印完成', 1);
								if(that.pageparam.p_pkval!=''&&that.pageparam.p_pkval!=undefined)
									that.pageparam.p_pkval='';
							}
							else
								that.pageparam.showsuccesswin = true;
							if(that.$parent.showratewin!=undefined)
								that.$parent.showratewin=false;
							that.showprintwin=false;
						}
					}
				}
				else if(index>list.length){
					if(that.iserror){//如果报错
						if(!that.isreshowrate)
						{
							if(that.$parent.showratewin!=undefined)
								that.$parent.showratewin=false;
							that.showprintwin=false;
						}
						else{
							if(that.$parent.showratewin!=undefined)
								that.$parent.showratewin=true;
							that.pageparam.showsuccesswin = false;
						}
					}
				}
			}
		},
		//合并文件
		MergePdf(){
			var that=this;
			this.$tool.loading('正在生成', this.divclass);
			this.$apipost.post.MergePdf({ diskpath: this.diskpath }).then(res => {
				this.$tool.loadingclose();
				if(res.state=='1'){
					if(res.labelurl!=undefined){
						this.$tool.message('生成完成', 1);
						that.$tool.OpenFile(that.$parent,unescape(res.labelurl));
						that.pageparam.showsuccesswin = true;
						that.showprintwin=false;
						that.pageparam.showprintwin=false;
					}
				}else{
					this.$tool.message(res.message, 0);
				}
			});
		},
		//下载面单位文件
		getzipfile(){
			var that=this;
			var paraminfo={
				 diskpath: this.diskpath 
			}
			this.$tool.loading('正在生成', this.divclass);
			this.$apipost.get.DownMdFile({ paraminfo: paraminfo}).then(res => {
				this.$tool.loadingclose();
				if(res.state=='1'){
					if(res.filename!=undefined){
						this.$tool.message('生成完成', 1);
						this.$tool.downfile(that,res.filename,'');
						that.showprintwin=false;
						that.$parent.showdownmd=false;
					}
				}else{
					that.$parent.showdownmd=true;
					this.$tool.message(res.message, 0);
				}
			});
		},
		//批量预览面单
		PrintPerView() {
			var that = this;
			this.$tool.loading('正在生成', that.pageparam.divclass);
			var orderinfo = JSON.parse(JSON.stringify(that.orderinfo));
			//orderinfo.printtype = '1';
			orderinfo.userid = localStorage.getItem('userid');
			this.$apipost.post.PrintPerView({ orderinfo: orderinfo }).then(res => {
				this.$tool.loadingclose();
				if (res.state == '1') {
					if (res.labelurl != undefined) {
						that.pageparam.showpdf = unescape(res.labelurl);
						that.pageparam.showsuccesswin = true;
					}
				} else {
					if (res.faillist != '') {
						this.$alert(res.message + ' ' + res.faillist, '提示', {
							confirmButtonText: '确定',
							callback: action => {}
						});
					} else {
						this.$tool.message(res.message, 0);
					}
				}
			});
			// orderinfo.printtype = '2';
			// this.$apipost.post.PrintPerView({ orderinfo: orderinfo }).then(res => {
			// 	if (res != '' && res != '1') {
			// 		eval(res);
			// 	}
			// });
		},
		//批量预览面单
		PrintPerView_Customs() {
			var that = this;
			this.$tool.loading('正在生成', that.pageparam.divclass);
			var orderinfo = JSON.parse(JSON.stringify(that.orderinfo));
			orderinfo.printtype = '3';
			orderinfo.userid = localStorage.getItem('userid');
			this.$apipost.post.PrintPerView({ orderinfo: orderinfo }).then(res => {
				this.$tool.loadingclose();
				if (res.state == '1') {
					if (res.labelurl != undefined) {
						if (that.funcode == '07') {
							that.pageparam.customerpdf = unescape(res.labelurl);
							if(that.diskpath!=''){
								//合并文件
								that.MergePdf();
							}
						}
						if(that.$parent.showratewin!=undefined)
							that.$parent.showratewin=false;
						that.pageparam.showsuccesswin = true;
						that.showprintwin=false;
					}
				} else {
					if (res.faillist != '') {
						this.$alert(res.message + ' ' + res.faillist, '提示', {
							confirmButtonText: '确定',
							callback: action => {}
						});
					} else {
						this.$tool.message(res.message, 0);
					}
				}
			});
		},
		//批量下单打印
		BatchPrint() {
			var that = this;
			// console.log(escape(JSON.stringify(this._data)));
			// if(2>1)
			// 	return false;
			console.log('批量下单');
			this.$tool.loading('正在下单', that.pageparam.divclass);
			this.$apipost.post.BatchCreateMd({ paraminfo: this._data }).then(res => {
				this.$tool.loadingclose();
				if (res.filename != undefined && res.filename != '') {
					that.pageparam.errorfile = unescape(res.filename);
				}
				if (res.state == '1') {
					//开始生成面单
					that.orderinfo = {
						userid: localStorage.getItem('userid'),
						batch: that.batch
					};
					that.PrintPerView();
				} else {
					if (res.filename != undefined && res.filename != '') {
						//表示下单错误的，需要下载
						that.pageparam.showsuccesswin = true;
					} else {
						this.$tool.message(res.message, 0);
					}
				}
			});
		},
		//多件下单
		MorePrint() {
			var that = this;
			// console.log(escape(JSON.stringify(this._data)));
			// if(2>1)
			// 	return false;
			console.log('多件下单');
			this.$tool.loading('正在下单', that.pageparam.divclass);
			this.$apipost.post.CreateMd_More({ paraminfo: this._data }).then(res => {
				this.$tool.loadingclose();
				if (res.filename != undefined && res.filename != '') {
					that.pageparam.errorfile = unescape(res.filename);
				}
				if (res.state == '1') {
					that.pageparam.showsuccesswin = true;
				} else {
					if (res.filename != undefined && res.filename != '') {
						//表示下单错误的，需要下载
						that.pageparam.showsuccesswin = true;
					} else {
						this.$tool.message(res.message, 0);
					}
				}
			});
		},
		CancelPrint(){
			if(this.isprint=='0')
				if (this.$parent.showsuccesswin != undefined) this.$parent.showsuccesswin = true;

			this.showprintwin = false;
		},
		ThreadPrint(orderlist){
			var that = this;
			if(that.checkedprintmode.length>0) //多线程操作只能操作选中的第一个选项
			{
				orderlist.forEach(e=>{
					e.e_code=that.checkedprintmode[0].e_code;
					e.e_modename=that.checkedprintmode[0].e_modename;
				});
			}
			var paraminfo = {
				orderlist: orderlist,
				handtype: that.handtype,
				userid: localStorage.getItem('userid'),
				otherparam:that.pageparam.checkedexpress,
				handleraccount:localStorage.getItem('u_account'),
				batch:that.batch
			};
			that.showprintwin=false;
			this.$emit('printcallback', {
				thread:true,
				paraminfo:paraminfo
			});
		}
	}
};
</script>

<style></style>
